/* eslint-disable */
import { useEffect } from 'react';
import EVENTS from "@/utils/Constants/Events";

// h-en stuff
const hanldeCellsHeight = () => {
  const tallerContentsArray = [];

  let heightLimit;

  const vw = Math.max(
    document.documentElement.clientWidth || 0,
    window.innerWidth || 0,
  );

  if (vw < 1123) {
    heightLimit = 46;
  } else {
    heightLimit = 60;
  }

  const cellContentsArr = [
    ...document.querySelectorAll('.bra-comparsionTable__cellContent'),
  ];
  cellContentsArr.forEach(cell => {
    if (cell.offsetHeight > heightLimit) {
      tallerContentsArray.push(cell);
    }
  });

  // console.log(tallerContentsArray)

  tallerContentsArray.forEach(cell => {
    let parentRow;
    parentRow = cell.parentNode.parentNode;

    const rowCells = [
      ...parentRow.querySelectorAll('.bra-comparsionTable__cell'),
    ];
    // console.log(cells)

    let index;

    rowCells.forEach(rowCell => {
      const rowCellsArr = [...rowCell.children];

      if (rowCellsArr.indexOf(cell) !== -1) {
        index = rowCells.indexOf(rowCell);
      }
    });

    const rows = [...document.querySelectorAll('.bra-comparsionTable__row')];
    const rowsCellsArr = [];
    const rowsCellsHeights = [];

    console.log(rows);

    rows.forEach(row => {
      rowsCellsArr.push(
        row.getElementsByClassName('bra-comparsionTable__cell')[index],
      );
    });

    rowsCellsArr.forEach(cell => {
      cell.style.height = 'auto';
      rowsCellsHeights.push(cell.scrollHeight);
    });

    console.log(Math.round(Math.max(...rowsCellsHeights)));

    rowsCellsArr.forEach(cell => {
      cell.style.height = `${Math.round(Math.max(...rowsCellsHeights)) +
        +20}px`;
    });

    if (vw < 1023) {
      const titles = [
        ...document.querySelectorAll('.bra-comparsionTable__mobileTitle '),
      ];
      const tableBody = document.querySelector('.bra-comparsionTable__body');

      const mobileRows = [
        ...tableBody.querySelectorAll('.bra-comparsionTable__row'),
      ];

      mobileRows.forEach((row, index) => {
        const mobileCells = [...row.children];

        mobileCells.forEach((cell, index) => {
          cell.style.marginTop = `${titles[index].scrollHeight}px`;
        });
      });
    } else {
      const deskCells = [
        ...document.querySelectorAll('.bra-comparsionTable__cell'),
      ];

      deskCells.forEach(cell => (cell.style.marginTop = 0));
    }
  });
};

export default () => {
  useEffect(() => {
    DLG.EVE.on(EVENTS.LISTING.COMPARE.TOGGLE, hanldeCellsHeight);
    window.addEventListener("resize", hanldeCellsHeight);
    return () => {
      window.removeEventListener("resize", hanldeCellsHeight)
    }
  }, []);
};
